import api from "lib/api";
import { useDispatch } from "react-redux";
import { updateUnreadAction, createAlertAction } from "data/app/appActions";
import { useCallback, useRef } from "react";
import { getErrorAlert } from "lib/api/errors";
import { AxiosError } from "axios";

export default function useUnreadCounts() {
	const dispatch = useDispatch();
	const apiErrorCount = useRef(0);
	const handleUnreadCount = useCallback(async () => {
		if (apiErrorCount.current < 4) {
			try {
				const result = await api.notifications.unreadCount();
				apiErrorCount.current = 0;
				dispatch(updateUnreadAction(result));
			} catch (error) {
				apiErrorCount.current = apiErrorCount.current + 1;
				const e = error as AxiosError;
				if (e.response && apiErrorCount.current === 4) {
					const code = e.response.status;
					if (code > 401) {
						dispatch(
							// Throw an alert
							createAlertAction(getErrorAlert(code, e))
						);
					}
				}
			}
		}
	}, [dispatch]);
	return handleUnreadCount;
}
